import React, { Component } from 'react';
import { map, isEmpty, truncate } from 'lodash';
import '../../styles/sidebar.css';
import { Button, Panel, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import CustomScroll from 'react-custom-scroll';
import { imageBasePath, appBasePath } from '../../constants/staticData';

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    const currentPath = window.location.pathname;
    this.state = {
      open: true,
      jobCountLoading: props.commonReducer && props.commonReducer.jobCountLoaded ? false : true,
      currentPath: currentPath,
      toolTipText: 'Customize your quotes and send them without even logging in.'
    };
  }
  componentWillMount() {
    if (
      !(this.props.commonReducer && this.props.commonReducer.jobCount && !isEmpty(this.props.commonReducer.jobCount))
    ) {
      this.props.actions.getJobCount();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.jobCountLoading && nextProps.commonReducer.jobCountLoaded) {
      this.setState({
        jobCountLoading: false
      });
    }
  }
  navigate(e, link) {
    e.preventDefault;
    e.stopPropagation;
    this.props.router.push(appBasePath + link);
  }
  render() {
    const style = {
      activeLink: {
        color: '#ED3124'
      }
    };

    const { bgColor, router: { params }, commonReducer, authReducer } = this.props;
    const authLocalStore = JSON.parse(localStorage.getItem('businessAuthData'));

    console.log("commonReducer.jobCount",commonReducer.jobCount);

    const sidebarItems = [
      {
        iconName: 'mdi mdi-speedometer',
        name: 'Overview',
        hyperLink: '/overview',
        active: false
      },
      {
        iconName: 'mdi mdi-briefcase-check',
        name: 'Open Jobs',
        hyperLink: '/open-jobs',
        active: false,
        subtab: [
          {
            subtabname: 'Waiting',
            subtabNotification: commonReducer.jobCount.waiting
              ? commonReducer.jobCount.waiting
              : this.state.jobCountLoading ? '..' : '0',
            link: '/open-jobs/waiting',
            newNotifications: commonReducer.jobCount.waitingNewJob ? `${commonReducer.jobCount.waitingNewJob} New` : '',
            active: false
          },
          {
            subtabname: 'Applied',
            subtabNotification: commonReducer.jobCount.applied
              ? commonReducer.jobCount.applied
              : this.state.jobCountLoading ? '..' : '0',
            link: '/open-jobs/applied',
            active: false
          },
          {
            subtabname: 'Confirmed',
            subtabNotification: commonReducer.jobCount.confirmed
              ? commonReducer.jobCount.confirmed
              : this.state.jobCountLoading ? '..' : '0',
            link: '/open-jobs/confirmed',
            active: false
          },
          {
            subtabname: 'In Progress',
            subtabNotification: commonReducer.jobCount.inprogress
              ? commonReducer.jobCount.inprogress
              : this.state.jobCountLoading ? '..' : '0',
            link: '/open-jobs/progress',
            active: false
          },
          {
            subtabname: 'Completed',
            subtabNotification: commonReducer.jobCount.completed
              ? commonReducer.jobCount.completed
              : this.state.jobCountLoading ? '..' : '0',
            link: '/open-jobs/completed',
            active: false
          }
        ]
      },
      {
        iconName: 'mdi mdi-history',
        name: 'Job History',
        hyperLink: '/job-history',
        active: false
      },
      {
        iconName: 'mdi mdi-message-text',
        name: 'Inbox',
        hyperLink: '/inbox',
        active: false
      },
      {
        iconName: 'mdi mdi-car',
        name: 'My Vehicles',
        hyperLink: '/my-Vehicles',
        active: false
      },
      {
        iconName: 'mdi mdi-account',
        name: 'Manage Users',
        hyperLink: '/manage-Users',
        active: false
      },
      {
        iconName: 'mdi mdi-domain',
        name: 'Company Profile',
        hyperLink: '/vendor-profile',
        active: false,
        subtab: [
          {
            subtabname: 'Manage Profile',
            link: '/vendor-profile/manage-profile',
            active: false
          },
          {
            subtabname: 'Manage Services',
            link: '/vendor-profile/manage-services',
            active: false
          },
          {
            subtabname: 'Reviews & Ratings',
            link: '/review-rating',
            active: false
          },
          {
            subtabname: 'Manage Offers',
            active: false
          }
        ]
      }
    ];

    const sideBarCardList = map(sidebarItems, (item, key) => {
      return (
        <li key={key} className={this.props.router.location.pathname.indexOf(item.hyperLink) !== -1 ? 'selected' : ''}>
          <a
            onClick={e => {
              this.props.router.push(appBasePath + item.hyperLink);
            }}
            style={this.props.router.location.pathname == appBasePath + item.hyperLink ? style.activeLink : {}}
          >
            {item.iconName && <label className={item.iconName} />}
            <span>{item.name}</span>
          </a>
          <ul className="list-unstyled subtab">
            {map(item.subtab, (subTabVal, key) => {
              return (
                <li
                  key={key}
                  onClick={e => {
                    this.navigate(e, subTabVal.link);
                  }}
                  className={subTabVal.subtabname.toLowerCase().indexOf(params.type) != -1 ? 'active' : ''}
                >
                  <span
                    style={this.props.router.location.pathname == appBasePath + subTabVal.link ? style.activeLink : {}}
                  >
                    {subTabVal.subtabname} {subTabVal.newNotifications && <a>{subTabVal.newNotifications}</a>}
                  </span>
                  {subTabVal.subtabNotification && <label>{subTabVal.subtabNotification}</label>}
                </li>
              );
            })}
          </ul>
        </li>
      );
    });
    return (
      <div style={{ backgroundColor: bgColor ? bgColor : '#fff' }} className={this.props.showSidebar ? "sidebar active" : "sidebar"}>
        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
          <ul className="scrollHeight list-unstyled">
            <li className="s-show">
              <div className="toggleBtn">
                <ToggleSwitch
                  checked={
                    this.props.authReducer &&
                    this.props.authReducer.authData &&
                    this.props.authReducer.authData.autoacceptjob
                  }
                  onChange={() => {
                    if (this.props.authReducer && this.props.authReducer.authData) {
                      this.props.actions.autoAcceptJob(!this.props.authReducer.authData.autoacceptjob);
                    }
                  }}
                  size="small"
                  ref={node => {
                    this.toggleSwitch = node;
                  }}
                />
                <label>
                  {this.props.authReducer &&
                  this.props.authReducer.authData &&
                  this.props.authReducer.authData.autoacceptjob
                    ? 'Auto Accept Job: On'
                    : 'Auto Accept Job: Off'}
                </label>
                <span>
                  <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="bottom"
                    overlay={
                      <Popover positionLeft={100} id="header-dropdown">
                        {' '}
                        {this.state.toolTipText.length < 50
                          ? this.state.toolTipText
                          : truncate(this.state.toolTipText, { length: 50, separator: ' ' })}
                      </Popover>
                    }
                  >
                    <i className="mdi mdi-information-outline" />
                  </OverlayTrigger>
                </span>
              </div>
            </li>
            <li className="s-show profile-collapse">
              <div className="profile-dropdown" onClick={() => this.setState({ open: !this.state.open })}>
                <div className="pofile-img">
                  <img src={`${imageBasePath}/pic.png`} className="picture" />
                </div>
                <div className="p-name">
                  <label>{authLocalStore && authLocalStore.name ? authLocalStore.name : ''}</label>
                </div>
                <div className="arrow-icon">
                  <i className={this.state.open ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                </div>
              </div>
              <Panel collapsible expanded={this.state.open}>
                <ul className="list-unstyled">
                  <li>
                    <a
                      onClick={() => {
                        this.props.router.push(`${appBasePath}/User-Accounts`);
                      }}
                    >
                      {' '}Settings{' '}
                    </a>
                  </li>
                  <li>
                    <a href=""> Payment </a>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={e => {
                        e.preventDefault();
                        this.props.actions.logout(this.props.router);
                        window.clearInterval();
                      }}
                    >
                      {' '}Logout{' '}
                    </a>
                  </li>
                </ul>
              </Panel>
            </li>
            {sideBarCardList}
          </ul>
        </CustomScroll>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Sidebar.jsx